module.exports = __webpack_public_path__ + "img/第3章_2-2_孔廟謎題圖_1.jpg";